module.exports = __webpack_public_path__ + "static/media/JohnShortland-300x300.9c7c4d81.png";